import React from 'react'
import moment from 'moment'

export const COLUMNS_TABLA_SILOS = [
  {
    name: 'nombreCortoToShow',
    label: 'Silo',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'sectorToShow',
    label: 'Sector',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'cerealConColor',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        const { color, cereal } = value
        return <div style={{ color: color }}>{cereal}</div>
      }
    }
  },
  {
    name: 'cerealVariedadConColor',
    label: 'Cereal Variedad',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        const { color, cerealVariedad } = value
        return <div style={{ color: color }}>{cerealVariedad === 'UNDEF' ? '' : cerealVariedad}</div>
      }
    }
  },
  {
    name: 'metrosDeVacio',
    label: 'Vacio (mts)',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${(value !== null) ? parseFloat(value).toFixed(0) : 0}`}
          </div>
        )
      }
    }
  },
  {
    name: 'estadoToShow',
    label: 'Estado',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'etiqueta',
    label: 'Etiqueta',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return value || 'S/E'
      }
    }
  },
  {
    name: 'fechaDeVaciado',
    label: 'Vaciado',
    options: {
      filter: true,
      sort: true,
      // customBodyRender: (value) => {
      //   return value ? value.split('.')[0] : ''
      // }
      customBodyRender: (value) => value ? <>{moment(value).format('DD/MM/YYYY')}</> : null
    }
  },
  {
    name: 'fechaInicioLlenado',
    label: 'Inicio Llenado',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => value ? <>{moment(value).format('DD/MM/YYYY')}</> : null
    }
  },
  {
    name: 'fechaFinLlenado',
    label: 'Fin Llenado',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => value ? <>{moment(value).format('DD/MM/YYYY')}</> : null
    }
  },
  {
    name: 'fechaUltimoFumigado',
    label: 'Fumigado',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => value ? <>{moment(value).format('DD/MM/YYYY')}</> : null
    }
  },
  {
    name: 'pesoNetoBaseVigente',
    label: 'Existencia [tns]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'espacioEnTns',
    label: 'Espacio [tns]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'espacioEnCamiones',
    label: 'Espacio [Camiones]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        if (typeof value === 'number' || (typeof value === 'string' && !isNaN(parseFloat(value)))) {
          return (
            <div style={{ textAlign: 'right', width: '80%' }}>
              {`${parseFloat(value).toFixed(0)}`}
            </div>
          )
        }
        return value
      }
    }
  },
  {
    name: 'pesoNetoTotalBaseVigente',
    label: 'Cap. B. Cereal [tns]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'pesoNetoTotalBaseTrigo',
    label: 'Cap. B. Trigo [tns]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'vejezSilo',
    label: 'Vejez',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        if (typeof value === 'number' || (typeof value === 'string' && !isNaN(parseFloat(value)))) {
          return (
            <div style={{ textAlign: 'right', width: '80%' }}>
              {`${parseFloat(value).toFixed(0)}`}
            </div>
          )
        }
        return value
      }
    }
  }
]

export const COLUMNS_TABLA_SILOS_TO_PRINT = [
  {
    name: 'nombreCorto',
    label: 'Nombre',
    width: 40,
    mantenerCase: true
  },
  {
    name: 'sector',
    label: 'Sector',
    mantenerCase: true,
    width: 40
  },
  {
    name: 'cereal',
    label: 'Cereal',
    mantenerCase: true,
    width: 50
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    mantenerCase: true,
    width: 50
  },
  {
    name: 'metrosDeVacio',
    label: 'Vacio (mtrs)',
    mantenerCase: true,
    width: 40
  },
  {
    name: 'estadoToShow',
    label: 'Estado',
    mantenerCase: true,
    width: 50
  },
  {
    name: 'etiqueta',
    label: 'Etiqueta',
    mantenerCase: true,
    width: 80
  },
  {
    name: 'fechaDeVaciado',
    label: 'Vaciado',
    mantenerCase: true,
    width: 50
  },
  {
    name: 'fechaInicioLlenado',
    label: 'Ini. llenado',
    mantenerCase: true,
    width: 50
  },
  {
    name: 'fechaFinLlenado',
    label: 'Fin llenado',
    mantenerCase: true,
    width: 50
  },
  {
    name: 'fechaUltimoFumigado',
    label: 'Fumigado',
    mantenerCase: true,
    width: 50
  },
  {
    name: 'pesoNetoTotalBaseVigente',
    label: 'Neto [tn]',
    mantenerCase: true,
    width: 50
  },
  {
    name: 'vejezSilo',
    label: 'Vejez',
    mantenerCase: true,
    width: 40
  },
  {
    name: 'pesoNetoTotalBaseTrigo',
    label: 'Neto Base Trigo [tn]',
    mantenerCase: true,
    width: 50
  },
  {
    name: 'ph',
    label: 'Ph',
    mantenerCase: true,
    width: 40
  }
]
